import { el } from 'redom';

import HelptapEditor from '../../helpers';

import { stringToSVG } from 'utilities';

import deleteNodeIconString from 'assets/images/delete-node-icon.svg?raw';

const deleteNodeIcon = stringToSVG(deleteNodeIconString);

class DeleteNodeButton {

  constructor(menu, configuration) {

    this.menu = menu;

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;

    this.el = el('button.delete-node-button', {
      type: 'button',
      onclick: this.handleButtonClick.bind(this)
    }, [deleteNodeIcon.cloneNode(true), el('label', 'Delete')]);

  }

  handleButtonClick() {

    const editor = this.editor;
    const activeNodePath = this.activeNodePath;

    HelptapEditor.deleteNodeByPath(editor, activeNodePath);
    HelptapEditor.tableOfContents.updateAll(editor);

    this.menu.onClose();

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;

  }

}

export default DeleteNodeButton;